export default __webpack_public_path__ + "static/media/value-A.9a1c6cd3.svg";